import api from "../utils/api";

const AUTH_BASE = "/api/authentication";

export const extractAuthToken = (payload) => {
  return (
    payload?.token ??
    payload?.access_token ??
    payload?.plainTextToken ??
    payload?.plain_text_token ??

    payload?.data?.token ??
    payload?.data?.access_token ??
    payload?.data?.plainTextToken ??
    payload?.data?.plain_text_token ??

    payload?.data?.data?.token ??
    payload?.data?.data?.access_token ??
    payload?.data?.data?.plainTextToken ??
    payload?.data?.data?.plain_text_token ??

    payload?.authentication?.token ??
    payload?.authentication?.access_token ??

    payload?.data?.authentication?.token ??
    payload?.data?.authentication?.access_token ??

    null
  );
};

export const extractAuthenticatedUser = (payload) => {
  return (
    payload?.user ??
    payload?.data?.user ??
    payload?.data?.data?.user ??
    payload?.authenticated_user ??
    payload?.data?.authenticated_user ??
    null
  );
};

export const login = async (payload) => {
  const response = await api.post(
    `${AUTH_BASE}/login`,
    payload,
  );

  return response.data;
};

export const register = async (payload) => {
  const response = await api.post(
    `${AUTH_BASE}/register`,
    payload,
  );

  return response.data;
};

export const getMe = async () => {
  const response = await api.get(
    `${AUTH_BASE}/me`,
  );

  return response.data;
};

export const updateProfile = async (payload) => {
  const response = await api.patch(
    `${AUTH_BASE}/profile`,
    payload,
  );

  return response.data;
};

export const updatePassword = async (payload) => {
  const response = await api.put(
    `${AUTH_BASE}/password`,
    payload,
  );

  return response.data;
};

export const logout = async () => {
  const response = await api.post(
    `${AUTH_BASE}/logout`,
  );

  return response.data;
};

export const logoutAll = async () => {
  const response = await api.post(
    `${AUTH_BASE}/logout-all`,
  );

  return response.data;
};